export const ProgressIndicatorThemes = {
  DEFAULT: 'default',
  BLOCKS: 'blocks',
  MINIMAL: 'minimal'
};
export default ProgressIndicatorThemes;